import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendEmployeeAverageAge } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendEmployeeAverageAgeState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number;
}

// 初期状態
export const jobRecommendListForTrendEmployeeAverageAgeInitialState: JobRecommendListForTrendEmployeeAverageAgeState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendEmployeeAverageAgeSlice = createSlice({
  name: 'jobRecommendListForTrendEmployeeAverageAge',
  initialState: jobRecommendListForTrendEmployeeAverageAgeInitialState,
  reducers: {
    setInitialDisplayFlagEmployeeAverageAge: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendEmployeeAverageAge.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getJobListForTrendEmployeeAverageAge.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(getJobListForTrendEmployeeAverageAge.rejected, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Create Action
export const { setInitialDisplayFlagEmployeeAverageAge } =
  jobRecommendListForTrendEmployeeAverageAgeSlice.actions;

// reducer
export const jobRecommendListForTrendEmployeeAverageAgeReducer =
  jobRecommendListForTrendEmployeeAverageAgeSlice.reducer;

interface State {
  jobRecommendListForTrendEmployeeAverageAge: JobRecommendListForTrendEmployeeAverageAgeState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendEmployeeAverageAgeLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendEmployeeAverageAge?.jobRecommendListForTrend
    .loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendEmployeeAverageAgeEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendEmployeeAverageAge?.jobRecommendListForTrend
    .entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagEmployeeAverageAgeSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendEmployeeAverageAge.initialDisplayFlag;
